import comp from "./ThirdPartyAuth";
export default comp;
